const BaseModel = require('./BaseModel');
const HTTPClient = require('../HTTPClient');

class Organisation extends BaseModel {
  static basePath = '/api/v1/organisations';
  static dataType = 'organisation';

  constructor(json) {
    super(json);
    this.parseToDates(['createdAt', 'updatedAt']);
    this.parseChildren(['entitlements']);
  }

  lock() {
    const path = `${this.constructor.basePath}/${this.id}/lock`;

    return new HTTPClient().put(path, { lock: true }).then(this);
  }

  unlock() {
    const path = `${this.constructor.basePath}/${this.id}/lock`;

    return new HTTPClient().put(path, { lock: false }).then(this);
  }

  merge(destinationId) {
    const path = `${this.constructor.basePath}/${this.id}/merge/${destinationId}`;

    return new HTTPClient().post(path).then(this);
  }
}

BaseModel.models[Organisation.dataType] = Organisation;
module.exports = Organisation;
